module.exports = __webpack_public_path__ + "fonts/boxicons.42d2adbb.woff2";